import { render, staticRenderFns } from "./printers_map.vue?vue&type=template&id=bc4ee0d2&"
import script from "./printers_map.vue?vue&type=script&lang=js&"
export * from "./printers_map.vue?vue&type=script&lang=js&"
import style0 from "./printers_map.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports